import React from "react";
import AgentContent from "../content/AgentContent.js";
import Layout from "../layout/Layout";

const Agents = () => {
  return (
    <Layout>
      <AgentContent />
    </Layout>
  );
};

export default Agents;
